module.exports = __webpack_public_path__ + "media/images/mobile/news/md_main-95ac4c94181b22912245f70072a65967.jpg";